import React from 'react';
import { Grid, Typography, Box, List, ListItem, ListItemText, Paper, Button } from '@mui/material';
import './homeStyle.css';
import { getDictionary, getField } from '@/app/utils/translation/translation';
import { getSvg } from '@/app/utils/svgUtils';

const HomeSection = ({ isMobile, language, translations, contactusRef, scrollToSection, }: { isMobile: boolean, language: any, translations: any, contactusRef: any, scrollToSection: any }) => {
    const dictionary = getDictionary(translations, 'home', language);
    const isArabic = language === 'arabic';

    return (
        <Grid container spacing={!isMobile && isArabic ? 2 : 2} alignItems="center" padding={isMobile ? "0px " : "30px"} marginTop={isMobile ? "5rem" : "5rem"}>
            <Grid item xs={12} md={6} style={{ order: isArabic ? 2 : 1 }}>
                <Paper elevation={3} className='paper-style' sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                    <Typography gutterBottom component="h1" variant="h1" fontWeight="bold" fontFamily="Century Gothic" fontSize={"15px"}>
                        {getField(dictionary, 'title', language)}
                    </Typography>
                    <Typography paragraph component="h2" variant="h2" fontWeight="bold" fontFamily="Century Gothic" fontSize={"25px"} sx={{ color: "var(--text-primary)" }}>
                        {getField(dictionary, 'inner-title', language)}<br />
                        {getSvg('arrowUpIcon', { mainPurple: 'var(--accent-primary)' }, { width: '70px', height: '70px' })}
                    </Typography>
                    <List sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                        <ListItem disablePadding sx={{ fontWeight: "bold", textAlign: isArabic ? 'right' : 'left' }}>
                            <ListItemText primary={<span style={{ fontWeight: "bold", opacity: 1, letterSpacing:isArabic ? ' ' :"1px", fontSize: "15px" }}><span style={{ color: 'var(--accent-primary)' }}>&#10004; </span>{getField(dictionary, 'list-item-one', language)} </span>} />
                        </ListItem>
                        <ListItem disablePadding sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                            <ListItemText primary={<span style={{ opacity: 1, letterSpacing: isArabic ? ' ' :"1px", fontWeight: "bold", fontSize: "15px" }}><span style={{ color: 'var(--accent-primary)' }}>&#10004; </span>{getField(dictionary, 'list-item-two', language)}</span>} />
                        </ListItem>
                        <ListItem disablePadding sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                            <ListItemText primary={<span style={{ opacity: 1, letterSpacing: isArabic ? ' ' :"1px", fontWeight: "bold", fontSize: "15px" }}><span style={{ color: 'var(--accent-primary)' }}>&#10004; </span> {getField(dictionary, 'list-item-three', language)}</span>} />
                        </ListItem>
                        <ListItem disablePadding sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                            <ListItemText primary={<span style={{ opacity: 1, letterSpacing:isArabic ? ' ' :"1px", fontWeight: "bold", fontSize: "15px" }}><span style={{ color: 'var(--accent-primary)' }}>&#10004; </span> {getField(dictionary, 'list-item-four', language)}</span>} />
                        </ListItem>
                    </List>
                    <Button
                        variant='contained'
                        sx={{
                            backgroundColor: "var(--accent-primary)",
                            marginTop: "10px",
                            transition: 'background-color 0.3s ease',
                            '&:hover': {
                                backgroundColor: "var(--accent-secondary)",
                            },
                        }}
                    >
                        <a href="#" rel="prefetch" onClick={() => scrollToSection(contactusRef)} style={{ textDecoration: 'none', color: 'white', fontSize: '15px' }}>
                            {getField(dictionary, 'request-demo', language)}
                        </a>

                    </Button>
                </Paper>
            </Grid>

            <Grid item xs={12} md={6} style={{ order: !isMobile && isArabic ? 1 : 2, marginTop: isMobile ? "20px" : 0 }}>
                <Box display="flex" justifyContent="center">
                    <img
                        src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/webp-images/home (1).webp`}
                        // loading="lazy"
                        width="800" 
                        height="600" 
                        alt="Illustration of a home page"
                        style={{ maxWidth: "90%", height: 'auto' }} 
                        fetchPriority="high"
                    />
                </Box>
            </Grid>

        </Grid >
    );
};

export default HomeSection;
